import { i18n } from '../../i18n';
import { getSavedFilters } from '../../hooks';
import { formatContainerType, momentTextFormat, exportExcel } from '../../utils';
import { containerStatues } from '../../const';

export const handleExportExcelClick = ({
  states,
  formattedData,
  user,
  currencyCode,
}: any) => {
  const oldFilters = getSavedFilters('belongs-to');
  let fileName = `REPORTS__${oldFilters.clientName}`;
  let startDate = states.startDate ? momentTextFormat(states.startDate, user, true) : '';
  let endDate = states.endDate ? momentTextFormat(states.endDate, user, true) : '';

  const excelData = formattedData.map((container: any) => ({
    [i18n.t('label.containerNumber')]: container.number,
    [i18n.t('label.type')]: formatContainerType(container.type),
    [i18n.t('label.condition')]: container.condition,
    [i18n.t('label.status')]: container.status,
    [i18n.t('label.containerContent')]: container.isLoadedText,
    [i18n.t('label.gateInDate')]: momentTextFormat(container.gateIn.completedAt, user, true),
    [i18n.t('label.gateOutDate')]: container.gateOut
      ? momentTextFormat(container.gateOut.completedAt as string, user, true)
      : '',
    [i18n.t('label.daysInTerminal')]: `${container.daysInTerminal} Days`,
    [i18n.t('label.payingDays')]: `${container.payingDays} Days`,
    [i18n.t('label.daysInTerminalPrice')]: container.daysInTerminalPrice,
    [i18n.t('label.craneInPrice')]: container.gateInCranePrice,
    [i18n.t('label.craneOutPrice')]: container.gateOutCranePrice,
  }));
  const filters = [
    {
      [i18n.t('common.client')]: oldFilters.clientName,
      [i18n.t('label.country')]: states.country,
      [i18n.t('label.city')]: states.city,
      [i18n.t('common.yard')]: oldFilters.yardName,
      [i18n.t('label.type')]: formatContainerType(states.type),
      [i18n.t('label.condition')]: states.condition,
      [i18n.t('label.status')]:
        containerStatues(true).find((status) => status.value === states.status)?.label || '',
      [i18n.t('label.from')]: startDate,
      [i18n.t('label.to')]: endDate,
      [i18n.t('label.currencyCode')]: currencyCode,
    },
  ];
  const sheets = [
    { data: excelData, sheetName: i18n.t('pages.reports.sheet.reports') },
    { data: filters, sheetName: i18n.t('pages.reports.sheet.filters') },
  ];

  if (startDate || endDate) {
    startDate = startDate || 'start';
    endDate = endDate || momentTextFormat(new Date(), user, true);
    fileName = `${fileName} ${startDate}__${endDate} ${currencyCode}`;
  }

  exportExcel({ sheets, fileName });
};
